export const CARD_IDENTIFICATION_STATUS = {
  INIT: 'init',
  SUCCESS: 'success',
  NOT_SUCCESS: 'notSuccess',
  FAILED: 'failed',
} as const;

export const CARD_STATUS = {
  ANONYMOUS: 'anonymous',
  SIMPLY_IDENTIFIED: 'simplyIdentified',
  DEBT_CARD: 'debtCard',
} as const;

export const CHECK_PAYMENT_CODE = {
  OK: 'OK',
  OPERATION_LIMIT_REACHED: 'OPERATION_LIMIT_REACHED',
  MONTH_LIMIT_REACHED: 'MONTH_LIMIT_REACHED',
  NOT_ENOUGH_BALANCE: 'NOT_ENOUGH_BALANCE',
  NO_CARD: 'NO_CARD',
} as const;

export const PIN_CODES = {
  PIN_SENT: 'PIN_SENT',
  PIN_NOT_NEEDED: 'PIN_NOT_NEEDED',
} as const;

export const MODAL_TYPES = {
  AUTH: 'auth',
  RELEASE: 'release',
  UPGRADE: 'upgrade',
  REFILL: 'refill',
  NOT_ENOUGH_BALANCE: 'notEnough',
  TRANSFER: 'transfer',
  DETAILS: 'details',
} as const;

export const enum ApiEndpoint {
  CardReplenish = '/_virtual_cards/wallet/card/replenish',
  CardPinCode = '/_virtual_cards/wallet/card/pin',
  CardInfo = '/_virtual_cards/wallet/card/info',
  CardDetails = '/_virtual_cards/wallet/card/details',
  Operations = '/_virtual_cards/wallet/card/operations',
  CardRefill = '/_virtual_cards/wallet/card/p2p',
  CardOpen = '/_virtual_cards/wallet/card/open',
  CardWithdraw = '/_virtual_cards/wallet/card/withdraw',
  CardIdentify = '/_virtual_cards/wallet/card/identify',
  CardCvc = '/_virtual_cards/wallet/card/cvc',
  //
  PassportRecognize = '/_virtual_cards/wallet/profile/recognize-identification-data',
  PaymentCheck = '/_virtual_cards/wallet/profile/check-payment',
  //
  OperationCheckThreeDs = '/_virtual_cards/wallet/operation/three-ds-v2-check',
  Settings = '/_virtual_cards/wallet/operation/settings',
}
